import Vue from 'vue'

import copyBtn from "./copy-btn/copy-btn"
import avatarView from "./avatar-view"

Vue.component("copy-btn", copyBtn);
Vue.component("avatar-view", avatarView);



// WEBPACK FOOTER //
// ./src/components/index.js